import './NavHeading.scss';

import React, { FC, useEffect } from 'react';

export interface NavHeadingProps {
  title: string;
  shortDescription?: string;
  helpLink?: string;
  helpLinkText?: string;
}

const NavHeading: FC<NavHeadingProps> = ({ title, shortDescription, helpLink, helpLinkText }) => {

  useEffect(() => {
    document.title = `${title} : BlabberJax Content OS`;
  }, [title]);

  const helpText = helpLinkText || 'Get help';

  if (!shortDescription && !helpLink) {
    return (
      <div className="nav-heading">
        <h1>
          {title}
        </h1>
      </div>
    );
  }

  if (!helpLink) {
    return (
      <div className="nav-heading">
        <h1>
          {title}
        </h1>
        <div className="row desc">
          <div className="col-md-12 gx-0">
            {shortDescription}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="nav-heading">
      <h1>
        {title}
      </h1>
      <div className="row desc">
        <div className="col-10 gx-0">
          {shortDescription}&nbsp;
          <a href={helpLink} target="_blank" rel="noreferrer" className="">
            {helpText}
          </a>
        </div>
      </div>
    </div>
  );
}

export default NavHeading;
